import React from 'react';
import { Link as BaseRouteLink } from 'react-router5';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { HrefText } from 'ds/components/typography';
import { Route } from 'config/routes';
import ArrowLeftIcon from 'assets/svg/chevron-left.svg';
import withEvents from 'analytics/withEvents';


const RouteLink = styled(BaseRouteLink)`
  ${({ theme }) => `
    align-self: start;
    display: flex;
    align-items: center;
    text-decoration: none;
    > svg {
      width: 12px;
      height: 24px;
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(0.5)};
      > path {
        fill: ${theme.colors.brand.main};
      }
      ${theme.isRTL ? '' : 'transform: rotate(180deg);'}
    }
  `}
`;

interface LinkToMadadLandingProps {
  onLinkClick?: () => void;
}

const BaseLinkToMadadLanding: React.FC<LinkToMadadLandingProps> = (props) => {
  const { onLinkClick } = props;
  const { t } = useLocale();
  const handleLinkClick = () => onLinkClick && onLinkClick();

  return (
    <RouteLink routeName={Route.MadadPage} target="_blank" onClick={handleLinkClick}>
      <HrefText>{t('madad.localWinners.linkToMadadLanding')}</HrefText>
      <ArrowLeftIcon />
    </RouteLink>
  );
};


export const LinkToMadadLanding = withEvents<LinkToMadadLandingProps>((sendEvent) => ({
  onLinkClick() {
    sendEvent('madad_click', 'madad');
  },
}))(BaseLinkToMadadLanding);
